<template>
  <div class="chat_wrapper" id="chatWrapper" :class="[pc == true?'pc':'']">
    <Header :headTitle="headTitle" />
    <div class="title_area">
      <div class="title_left">
        <img src="~assets/images/ana-big.png" alt />
        <span>{{liveInfo.analystName}}</span>
      </div>
      <div class="title_right">
        <div class="right_top">
          <div class="top_left">{{liveInfo.answerName}}</div>
          <div class="top_right" @click="showContent = !showContent">
            <div class="info" v-show="showContent">
              观点为讲师个人观点，不代表创富立场，意见仅供参
              考，投资者应独立判断，谨慎评估并自负投资风险;
            </div>
          </div>
        </div>
        <div class="right_bottom">
          <div class="bottom_left">
            <ul>
              <li
                v-for="(item,index) in productPramas"
                :key="index"
                @click="goMarket(item.symbol)"
              >{{item.name}}</li>
            </ul>
          </div>
          <div class="bottom_right">
            <span v-show="liveInfo.status != 2">{{liveInfo.startTime}}~{{liveInfo.endTime}}</span>
            <div
              class="status"
              :class="[{'ing':liveInfo.status == 1},{'future':liveInfo.status == 0},{'ever':liveInfo.status == 2}]"
            >
              <i></i>
              <span>{{liveInfo.status | filterText }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 未开始 -->
    <div v-show="liveInfo.status == 0">
      <div class="hope_time">
        <div>期待您的参与</div>
        <span>{{liveInfo.answerDate}} {{liveInfo.startTime}}~{{liveInfo.endTime}}</span>
      </div>
      <div class="hot_list">
        <div class="title">
          <img src="~assets/images/index/hot_brand.png" alt />
        </div>
        <answer-party :hotQuestion="hotData"></answer-party>
      </div>
    </div>

    <div v-show="liveInfo.status != 0">
      <div>
        <div class="tab_list">
          <ul>
            <li
              :class="[showActive == index?'active':'']"
              v-for="(item,index) in tabList"
              :key="index"
              @click="showTab(index)"
            >{{item}}</li>
          </ul>
          <i v-show="showPoint == true"></i>
        </div>
        <div class="chat_part" :class="[showTopMessage == true?'top':'']">
          <Top v-show="showTopMessage" :topMessageData="topMessageData" />
          <div
            ref="chat_inner"
            :class="['chat_inner',{'heightAdd':heightAdd == true}]"
            :style="{height:chatWindowHeight+'px'}"
          >
            <div style="height:100%">
              <div v-show="showLoading" class="loading-wrapper">
                <van-loading size="24px">加载中...</van-loading>
              </div>
              <div class="chat_wrapper_inner" ref="wrapper">
                <ul class="chat_list" ref="container" v-show="showMoreContent">
                  <li v-for="(item,index) in messageList" :key="index">
                    <div class="chat_top">
                      <div class="ava">
                        <img :src="item.fromImage | filterImage" alt />

                        <span class="name">{{item.fromName}}</span>
                      </div>
                      <div class="time">{{item.receiveTime | subTime}}</div>
                    </div>
                    <div class="chat_bottom">
                      <span v-show="item.messageType != 1" v-html="item.message" @click="goToProduct(item.message)"></span>
                      <span v-show="item.messageType == 1">
                        <img class="litter_pic" @click="showBig(item.message)" :src="item.message" />
                      </span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            <!-- <div v-show="showActive == 0 && liveInfo.status == 1" class="live_info">游客21457 进入问答</div> -->
          </div>
        </div>
      </div>
    </div>
    <!-- 未登录提醒 -->
    <div>
      <login-popup :showPopup="showPopup" />
    </div>
    <van-popup v-model="showLoginPopup" :close-on-click-overlay="false">
      <re-Login @reconnect="updateRouter"></re-Login>
    </van-popup>

    <input-area
      v-show="(showActive == 0 || showActive == 3) && liveInfo.status == 1"
      @sendMsg="sendMsg"
      @addHeight="addHeight"
      @resetHeight="resetHeight"
      @lockScreen="lockScreen"
      @parentScrollTop="scrollTop"
      @showImgLoad="showImgLoad"
      @focus="focus"
      @hideBg="hideBg"
      ref="inputArea"
      :liveId="liveId"
      :companyId="companyId"
    ></input-area>
    <van-image-preview :images="images"></van-image-preview>
    <div v-if="showPopupCharts" >
        <van-popup v-model="showCharts" @click-overlay='close'><e-charts :code="echartsCode" ></e-charts></van-popup>

    </div>
     <load-ing v-show="showWebsocket"></load-ing>
    <div class="focus_bg" v-show="showFocusBg" @click="hideBg"></div>
  </div>
</template>

<script>
import Header from "./components/header";
import inputArea from "./components/inputArea/inputArea";
import Top from "./components/top/topTitle";
import answerParty from "components/answerParty";
import loginPopup from "./components/loginPopup/loginPopup";
import reLogin from "./components/loginPopup/reLogin";
import { guid } from "@/assets/commonjs/tool";
import { getStore } from "assets/commonjs/storage";
import user from "assets/commonjs/userInfo";
import BScroll from "better-scroll";
import { toast } from "assets/commonjs/toast";
const MessageDataProto = require("@/assets/commonjs/MessageDataProto_pb.js");
let webSocket = null;
import { mapState, mapActions } from "vuex";
import loadIng from "components/loading/loading";
import { ImagePreview } from "vant";
import eCharts from "./components/eCharts"
export default {
  data() {
    return {
      headTitle: "在线问答",
      showActive: 0,
      tabList: ["实时问答", "分析师发言", "与我相关", "客服小雨"],
      showContent: false, //问号内容显示隐藏
      showPopup: false, //弹窗显示与否
      winHeight: "", // 窗口高度
      chatWindowHeight: "", //聊天列表高度
      heightAdd: false, //高度增加
      liveInfo: "", // 直播课信息
      liveStatus: "ing",
      chatUrl:  process.env.VUE_APP_CHAT_URL.split(".").map((str, index) => index == 1 ? window.location.hostname.split(".")[1] : str).join("."),
      userInfo: "", // 用户登录信息
      requestedId: "",
      messageId: "",
      loginType: "", // 操作类型 登录
      aliveType: "", // 心跳
      serveSingle: "", // 私聊
      allChat: "", // 群聊
      companyId: "", // 公司 id
      liveId: "", // 直播间 id
      liveName: "", // 直播名称
      mutiLogin: false, // 多端登录标识
      isPrivateTalk: false, // 私聊否
      clientType: "0", // 用户端类型
      userType: "", // 用户类型 （真实 模拟 游客 客服 分析师）
      textType: MessageDataProto.MessageData.MessageType.TEXT, // 消息类型
      pictureType: MessageDataProto.MessageData.MessageType.PICTURE, // 消息类型
      delateType: MessageDataProto.MessageData.MessageDataType.DELETE_MESSAGE, // 消息类型
      topType: MessageDataProto.MessageData.MessageDataType.MESSAGE_UP, // 消息类型
      from: "", // 发送者的唯一标识
      fromName: "", // 发送者昵称
      fromImage: "", // 发送者图像
      messageList: [], //公聊信息
      privateMessageList: [], //个人同客服私聊的内容
      analystMessageList: [], //分析师发言
      aboutMetMessageList: [], //与我相关发言
      commonMessageList: [],
      lockLock: true, //锁屏
      productPramas: [],
      showPoint: false, //显示私聊原点
      firstHistoryMessageId: "", //公共聊天室历史消息的第一条
      firstHistoryAnalystMessageId: "", //分析师历史消息的第一条
      firstHistoryAboutMeMessageId: "", //与我相关历史消息的第一条
      firstHistoryServeMessageId: "", //客服历史消息的第一条
      hideListLoading: false, //聊天列表中的加载loading
      showLoad: false, //是否显示加载中
      showTopMessage: false, //显示置顶消息
      topMessageData: {},
      bigImgVal: "",
      stopHeart: true,
      showLoading: false,
      showLoginPopup: false, //决定websocket  是否连接
      showFocusBg: false, //安卓键盘弹起背景显示
      showWebsocket: true,
      reactWebsocket: false,
      reconnectWebsocket: true,
      images: [],
      imagesArrAnalyst: [], //分析师相关的图片
      imagesArrCommon: [], //公聊的图片
      imagesArrMe: [], //私聊的图片
      instance_before: "",
      instance_after: "",
      instance_third: "",
      pc: false,
      showMoreContent: true,
      dataLength: 0,
      loadMoreMessage: "",
      ifLoadData: false, //是否是最新加载的数据
      showCharts:false,
      echartsCode:'',
      showPopupCharts:false
    };
  },
  computed: {
    ...mapState(["hotData"])
  },
  //在路由离开的时候，关闭预览的图片
  beforeRouteLeave(to, from, next) {
    if (this.showActive == 0) {
      if (this.instance_before != "") {
        this.instance_before.close();
      }
    } else {
      if (this.instance_after != "") {
        this.instance_after.close();
      }
    }
    next();
  },
  methods: {
    ...mapActions(["getStrageData"]),
    showTab(index) {
      this.showActive = index;
      this.isPrivateTalk = false;

      if (index == 0) {
        this.messageList = this.commonMessageList;
      } else if (index == 1) {
        this.messageList = this.analystMessageList;
      } else if (index == 2) {
        this.messageList = this.aboutMetMessageList;
      } else if (index == 3) {
        //私聊
        this.messageList = this.privateMessageList;
        this.deleteUserMessageMark(this.liveId);

        this.isPrivateTalk = true;
      }

      // 滑动到指定元素,设置动画300ms
      let _this = this;
      setTimeout(function() {
        _this.scroll.refresh();
        let Lis = _this.$refs.container.querySelectorAll("li");
        _this.scroll.scrollToElement(Lis[Lis.length - 1], 300);
      }, 100);
    },
    getLiveInfo(id) {
      let data = {
        liveId: id,
        companyId: this.userInfo.companyId
      };
      this.$api.answerList.queryLive(data).then(res => {
        if (res.data.code == 0) {
          this.liveInfo = res.data.result;
          if (this.liveInfo.status == 0) {
            this.getStrageData();
          }
          if (this.liveInfo.status == 0 || this.liveInfo.status == 2) {
            this.showWebsocket = false;
          }
          if (res.data.result.productCode != "") {
            this.productPramas = this.getProductData(
              res.data.result.productCode
            );
          }
        }
      });
    },
    goMarket(symbol) {
      user.goTrade(symbol);
    },
    getProductData(code) {
      let productPramas = [];

      this.$api.strageList.getProductDataSingle(code).then(res => {
        let ampName, symbol;
        if (res.data) {
          let data = res.data.data;
          for (let i in data) {
            ampName = data[i].name;
            symbol = data[i].symbol;
            productPramas.push({
              name: ampName,
              symbol: symbol
            });
          }
        }
      });

      return productPramas;
    },
    getRequestedId() {
      this.requestedId = guid();
    },
    getMessageId() {
      this.messageId = guid();
    },
    initChatInfo() {
      let MessageDataType = MessageDataProto.MessageData.MessageDataType;
      this.loginType = MessageDataType.LOGIN;
      this.aliveType = MessageDataType.ALIVE;
      this.serveSingle = MessageDataType.SERVICE_SINGLE;
      this.allChat = MessageDataType.ALL;
    },

    initUserInfo() {
      let userInfo = new MessageDataProto.MessageData();
      userInfo.setMessagedatatype(this.loginType);
      // userInfo.setMessage(this.userIpInfo());
      let messageArray = this.comonUserInfo(userInfo).serializeBinary();
      webSocket.send(messageArray);
    },
    // userIpInfo() {
    //   let userSource, userDevice, userIpInfo;
    //   if (
    //     getStore("noneheader") != "" &&
    //     getStore("noneheader") != undefined &&
    //     getStore("noneheader") != null
    //   ) {
    //     userSource = "App";
    //   } else {
    //     userSource = "M站";
    //   }
    //   if (user.mechined() == 0) {
    //     userDevice = "Android";
    //   } else if (user.mechined() == 1) {
    //     userDevice = "IOS";
    //   } else {
    //     userDevice = "PC";
    //   }
    //   userIpInfo = {
    //     userIp: returnCitySN["cip"],
    //     userSource: userSource,
    //     userAddress: returnCitySN["cname"],
    //     userDevice: userDevice,
    //     userDeviceDetail: navigator.userAgent
    //   };
    //   return JSON.stringify(userIpInfo);
    // },
    comonUserInfo(userInfo) {
      this.getRequestedId();
      this.getMessageId();
      userInfo.setRequestid(this.requestedId); // uuid
      // uuid
      userInfo.setMessageid(this.messageId);
      userInfo.setCompanyid(this.userInfo.companyId);
      userInfo.setLivename(this.liveName);
      userInfo.setLiveid(this.liveId);
      userInfo.setClienttype(this.clientType);
      userInfo.setFrom(this.userInfo.userToken);
      userInfo.setFromtype(this.userInfo.userType); //
      userInfo.setFromaccount(this.userInfo.account);
      userInfo.setFromlevel(this.userInfo.userLevel);
      userInfo.setFromname(this.userInfo.displayName);
      userInfo.setFromimage(this.userInfo.userImage);
      return userInfo;
    },
    initWebsocket() {
      if (typeof WebSocket === undefined) {
        alert("您的浏览器不支持socket");
      } else {
        let _this = this;
        webSocket = new WebSocket(this.chatUrl);
        webSocket.binaryType = "arraybuffer";
        webSocket.onopen = function() {
          // console.log("建立连接...");
          _this.stopHeart = true;
          _this.reconnectWebsocket = true;
          _this.initUserInfo();
        };
        webSocket.onerror = function(e) {
          let code = e.code;
          let wasClean = e.wasClean;
          _this.stopHeart = false;
          if (_this.mutiLogin == false) {
            if (code == 1005 && wasClean == true) {
              return;
            }
            if (_this.reconnectWebsocket) {
              _this.reconnectWebsocket = false;
              _this.showWebsocket = false;
              _this.showLoginPopup = true;
            }
          }
        };
        webSocket.onclose = function(e) {
          // console.log("断开连接...");
          let code = e.code;
          let wasClean = e.wasClean;
          _this.stopHeart = false;
          if (_this.mutiLogin == false) {
            if (code == 1005 && wasClean == true) {
              return;
            }
            if (_this.reconnectWebsocket) {
              _this.reconnect()
            }
          }
        };
        window.onbeforeunload = function() {
          webSocket.close();
        };
        // 路由跳转时结束websocket链接
        _this.$router.afterEach(function() {
          webSocket.close();
        });
        webSocket.onmessage = function(e) {
          if (typeof e.data === "string") {
            return;
          }
          let data = MessageDataProto.MessageData.deserializeBinary(e.data);
          let messageType = data.getMessagedatatype();

          switch (messageType) {
            case 1:
              // 连接成功
              // console.log("连接成功");
              _this.showWebsocket = false;
              _this.mutiLogin = false;
              break;
            case 4:
              // 客服私聊
              // console.log("私聊");
              var priveteMsgObj = _this.getMsgObj(data);
              // 自己发送
              if (data.getFrom() == _this.userInfo.userToken) {
                _this.setContent(priveteMsgObj, true, data.getFrom());
              } else {
                _this.setContent(priveteMsgObj, false, data.getTo());
              }
              if (priveteMsgObj[0].messageType == 1) {
                _this.imagesArrMe.push(priveteMsgObj[0].message);
              }

              break;
            case 5:
              // 群发
              // console.log("群聊");

              var commonMsgObj = _this.getMsgObj(data);

              if (data.getFrom() == _this.userInfo.userToken) {
                _this.setContent(commonMsgObj, true);
              } else {
                _this.setContent(commonMsgObj, false);
              }
              //公聊相关的图
              if (commonMsgObj[0].messageType == 1) {
                _this.imagesArrCommon.push(commonMsgObj[0].message);
              }
              //分析师发言
              if (data.getFromname() == _this.liveInfo.analystName) {
                //分析师相关的图
                if (commonMsgObj[0].messageType == 1) {
                  _this.imagesArrAnalyst.push(commonMsgObj[0].message);
                }
                _this.analystMessageList = _this.analystMessageList.concat(
                  commonMsgObj
                );
                _this.firstHistoryAnalystMessageId =
                  _this.analystMessageList[0].messageId;
              }
              if (
                data.getFrom() == _this.userInfo.userToken ||
                data.getTo() == _this.userInfo.userToken
              ) {
                //与自己相关
                _this.aboutMetMessageList = _this.aboutMetMessageList.concat(
                  commonMsgObj
                );
                _this.firstHistoryAboutMeMessageId =
                  _this.aboutMetMessageList[0].messageId;
              }

              break;
            case 6:
              // 消息置顶
              // console.log("消息置顶");
              // console.log(data)
              var topMsgObj = _this.getMsgObj(data);
              _this.getTopMessage(topMsgObj);
              break;
            case 7:
              // 消息删除
              // console.log("删除消息");
              _this.deleteMessgeComPri(data);
              break;
            case 8:
              // console.log("消息返回");

              // 消息返回
              break;
            case 9:
              // 消息已读
              break;
            case 10:
              // 用户上线
              // console.log("用户上线");
              // _this.queryUser()
              break;
            case 11:
              // 用户上线
              // console.log("用户下线");
              // _this.queryUser()
              break;
            case 2:
              // console.log(data.getMessage());
              break;
            case 12:
               _this.mutiLogin = true;
              // console.log("多端登录");
              // toast("您的账号已经在其他客户端登录！");
              // _this.showPopup = true;
              break;
            case 26:
              _this.showPopupEnd();
              break;
            case 27:
              toast("您已被禁言，请联系客服！");
              break;
            case 28:
              toast(data.getMessage());
              break
          }
        };
      }
    },
    sendMsg(val) {
      let userInfo = new MessageDataProto.MessageData();
      // 公聊
      if (!this.isPrivateTalk) {
        userInfo.setMessagedatatype(this.allChat);
      } else {
        // 私聊
        userInfo.setMessagedatatype(this.serveSingle);
      }
      // 如果发送的是图片
      if (val != undefined && val.label == "image") {
        // alert("图片");
        // alert(val.val);
        userInfo.setMessagetype(this.pictureType);
        userInfo.setMessage(val.val);
      } else {
        userInfo.setMessagetype(this.textType);
        // let msg = this.filterTalkContent(val);
        userInfo.setMessage(val);
      }

      // @某人

      // 回复某人

      let messageArray = this.comonUserInfo(userInfo).serializeBinary();

      webSocket.send(messageArray);
      this.$refs.inputArea.clearContent();
      // this.lockLock = true;

      var u = navigator.userAgent;
      var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
      if (isAndroid) {
        this.showFocusBg = false;
        this.$refs.inputArea.blur();
      }
      //兼容ios 适配
      window.scrollTo(0, document.documentElement.clientHeight);
    },
    updateRouter() {
      this.$router.go(0);
      this.showLoginPopup = false;
    },
    reconnect() {
      this.reconnectWebsocket = true;
      if (!this.mutiLogin) {
        this.showWebsocket = true;
        this.initWebsocket();
        this.loadMethods();
      }
    },
    loadMethods() {
      //加载实时问答的历史消息
      this.loadHistoryMessage(this.liveId);
      //加载置顶消息
      // this.getTopHistoryMessage(this.liveId)
      //查询用户的消息数量
      this.getServiceMessageCount(this.liveId);
      this.loadAnalystHistoryMessage(this.liveId);
      this.loadAboutMeHistoryMessage(this.liveId);
      this.loadSeverHistoryMessage(this.liveId);
    },
    // 处理发送的文字
    // filterTalkContent(content) {
    //   let msg = clearMsgHtml(content);
    //   if (isBlank(msg)) {
    //     this.$refs.inputArea.clearContent();
    //     return false;
    //   }
    //   return msg;
    // },
    lockScreen(val) {
      if (val) {
        this.lockLock = false;
      } else {
        this.lockLock = true;
      }
    },
    setContent(msgObj, isMeSend, userToken) {
      this.ifLoadData = false;
      // 如果是客服私聊我 我不在聊天框
      if (this.isPrivateTalk == false && isMeSend == false && userToken) {
        this.showPoint = true;
        this.privateMessageList = this.privateMessageList.concat(msgObj);
        this.firstHistoryServeMessageId = this.privateMessageList[0].messageId;
      } else if (this.isPrivateTalk && userToken) {
        //客服私聊在聊天框
        this.privateMessageList = this.privateMessageList.concat(msgObj);
        this.messageList = this.privateMessageList;
        this.firstHistoryServeMessageId = this.messageList[0].messageId;
      } else {
        // 公聊
        this.commonMessageList = this.commonMessageList.concat(msgObj);

        if (this.showActive == 0 && !this.isPrivateTalk) {
          this.messageList = this.commonMessageList;
        }
        this.firstHistoryMessageId = this.messageList[0].messageId;
      }
      this.showLoad = false;
    },
    addHeight() {
      this.heightAdd = true;
    },
    resetHeight() {
      this.heightAdd = false;
    },
    scrollTop() {
      this.scroll.scrollTo(0, this.scroll.maxScrollY);
    },
    // 获取浏览器高度
    autodivheight() {
      // 获取浏览器窗口高度
      if (window.innerHeight) {
        this.winHeight = window.innerHeight;
        this.winWidth = window.innerWidth;
      } else if (document.body && document.body.clientHeight) {
        this.winHeight = document.body.clientHeight;
      }
      if (document.documentElement && document.documentElement.clientHeight) {
        this.winHeight = document.documentElement.clientHeight;
      }

      this.chatWindowHeight = this.winHeight - 190;
    },
    getMsgObj(data) {
      let msgObj = [
        {
          messageDataType: data.getMessagedatatype(),
          companyId: data.getCompanyid(),
          liveId: data.getLiveid(),
          liveName: data.getLivename(),
          from: data.getFrom(),
          fromType: data.getFromtype(),
          fromLevel: data.getFromlevel(),
          fromName: data.getFromname(),
          fromImage: data.getFromimage(),
          to: data.getTo(),
          toType: data.getTotype(),
          toLevel: data.getTolevel(),
          toName: data.getToname(),
          toImage: data.getToimage(),
          messageType: data.getMessagetype(),
          messageId: data.getMessageid(),
          message: data.getMessage(),
          msgSeq: data.getMsgseq(),
          receiveTime: data.getReceivetime()
        }
      ];

      return msgObj;
    },
    ifShowLoad(more) {
      if (more == "loadMore") {
        this.showLoad = false;
      } else {
        this.showLoad = true;
      }
    },
    //加载实时公聊消息
    loadHistoryMessage(id, more) {
      // this.ifShowLoad(more);
      let data = {
        liveId: id,
        messageId: this.firstHistoryMessageId,
        companyId: this.userInfo.companyId,
        pageSize: 10
      };

      this.$api.answerList.queryCommonMessage(data).then(res => {
        if (res.status == 200) {
          if (res.data.length == 0) {
            if (more == "loadMore") {
              this.dataLength = res.data.length;
              this.loadMoreMessage = "";
              toast("没有更多数据了");
            } else {
              this.showLoad = false;
            }
          } else {
            this.commonMessageList = res.data.concat(this.commonMessageList);
            this.messageList = this.commonMessageList;
            for (var i in this.commonMessageList) {
              if (this.commonMessageList[i].messageType == 1) {
                this.imagesArrCommon.push(this.commonMessageList[i].message);
              }
            }
            this.firstHistoryMessageId = this.commonMessageList[0].messageId;
            if (more == "loadMore") {
              this.dataLength = res.data.length;
            }
          }
        }

        this.showLoading = false;
      });
    },
    //加载分析师历史消息
    loadAnalystHistoryMessage(id, more) {
      // this.ifShowLoad(more);
      let data = {
        liveId: id,
        messageId: this.firstHistoryAnalystMessageId,
        companyId: this.userInfo.companyId,
        pageSize: 10
      };
      this.$api.answerList.queryAnalystMessage(data).then(res => {
        if (res.status == 200) {
          if (res.data.length == 0 && more == "loadMore") {
            this.dataLength = res.data.length;
            this.loadMoreMessage = "";
            toast("没有更多数据了");
          } else if (res.data.length == 0) {
            this.showLoad = false;
          } else {
            this.analystMessageList = res.data.concat(this.analystMessageList);
            for (var i in this.analystMessageList) {
              if (this.analystMessageList[i].messageType == 1) {
                this.imagesArrAnalyst.push(this.analystMessageList[i].message);
              }
            }
            if (this.showActive == 1) {
              this.messageList = this.analystMessageList;
            }
            this.firstHistoryAnalystMessageId = res.data[0].messageId;
            if (more == "loadMore") {
              this.dataLength = res.data.length;
            }
          }
        }
        this.showLoading = false;
        // this.showLoad = false;
      });
    },
    //加载自己相关的历史消息
    loadAboutMeHistoryMessage(id, more) {
      // this.ifShowLoad(more);
      let data = {
        liveId: id,
        messageId: this.firstHistoryAboutMeMessageId,
        companyId: this.userInfo.companyId,
        pageSize: 10,
        userToken: this.userInfo.userToken
      };
      this.$api.answerList.queryRelatedMessage(data).then(res => {
        if (res.status == 200) {
          if (res.data.length == 0 && more == "loadMore") {
            this.dataLength = res.data.length;
            this.loadMoreMessage = "";
            toast("没有更多数据了");
          } else if (res.data.length == 0) {
            this.showLoad = false;
          } else {
            this.aboutMetMessageList = res.data.concat(
              this.aboutMetMessageList
            );
            if (this.showActive == 2) {
              this.messageList = this.aboutMetMessageList;
            }
            this.firstHistoryAboutMeMessageId = res.data[0].messageId;
            if (more == "loadMore") {
              this.dataLength = res.data.length;
            }
          }
        }
        this.showLoading = false;
        // this.showLoad = false;
      });
    },
    //加载客服相关的历史消息
    loadSeverHistoryMessage(id, more) {
      // this.ifShowLoad(more);
      let data = {
        liveId: id,
        messageId: this.firstHistoryServeMessageId,
        companyId: this.userInfo.companyId,
        pageSize: 10,
        userToken: this.userInfo.userToken
      };
      this.$api.answerList.queryServiceMessage(data).then(res => {
        if (res.status == 200) {
          if (res.data.length == 0 && more == "loadMore") {
            this.dataLength = res.data.length;
            this.loadMoreMessage = "";
            toast("没有更多数据了");
          } else if (res.data.length == 0) {
            this.showLoad = false;
          } else {
            this.privateMessageList = res.data.concat(this.privateMessageList);
            for (var i in this.privateMessageList) {
              if (this.privateMessageList[i].messageType == 1) {
                this.imagesArrMe.push(this.privateMessageList[i].message);
              }
            }
            if (this.showActive == 3) {
              this.messageList = this.privateMessageList;
            }
            this.firstHistoryServeMessageId = res.data[0].messageId;
            if (more == "loadMore") {
              this.dataLength = res.data.length;
            }
          }
        }
        this.showLoading = false;
        // this.showLoad = false;
      });
    },
    getMessageList() {
      //true 标识 表示可以滚动到底部
      // false表示不滚动到底部 下拉刷新时不滚动到底部

      this.showMoreContent = false;
      this.loadMoreMessage = "loadMore";
      this.ifLoadData = true;
      if (this.showActive == 0) {
        this.loadHistoryMessage(this.liveId, "loadMore");
      } else if (this.showActive == 1) {
        this.loadAnalystHistoryMessage(this.liveId, "loadMore");
      } else if (this.showActive == 2) {
        this.loadAboutMeHistoryMessage(this.liveId, "loadMore");
      } else if (this.showActive == 3) {
        this.loadSeverHistoryMessage(this.liveId, "loadMore");
      }
    },
    deleteMessgeComPri(data) {
      // console.log(data)
      if (
        (data.getFrom() != "" &&
          data.getFrom() != undefined &&
          data.getFrom() != null) ||
        (data.getTo() != "" &&
          data.getTo() != undefined &&
          data.getTo() != null)
      ) {
        for (let i in this.privateMessageList) {
          if (this.privateMessageList[i].messageId == data.getMessageid()) {
            this.privateMessageList.splice(i, 1);
          }
        }
      } else {
        for (let i in this.commonMessageList) {
          if (this.commonMessageList[i].messageId == data.getMessageid()) {
            this.commonMessageList.splice(i, 1);
          }
        }
      }
      if (this.showActive == 0) {
        this.messageList = this.commonMessageList;
      } else if (this.showActive == 3) {
        this.messageList = this.privateMessageList;
      }
    },
    getTopMessage(data) {
      this.topMessageData = {
        fromName: data.fromName,
        message: data.message
      };
      this.showTopMessage = true;
      this.chatWindowHeight = this.chatWindowHeight - 120;
    },
    getTopHistoryMessage(id) {
      let data = {
        liveId: id,
        companyId: this.userInfo.companyId
      };
      this.$api.answerList.queryTopChatMessage(data).then(res => {
        // console.log(res)
        if (res.data != null && res.data != "") {
          this.getTopMessage(res.data);
        } else {
          this.showTopMessage = false;
        }
      });
    },
    showPopupEnd() {
      toast("直播已经结束");
      this.liveInfo.status = 2;
      this.showFocusBg = false;
    },
    getServiceMessageCount(id) {
      let data = {
        liveId: id,
        userToken: this.userInfo.userToken,
        companyId: this.userInfo.companyId
      };
      this.$api.answerList.queryServiceMessageCount(data).then(res => {
        if (res.data == true) {
          this.showPoint = true;
        } else {
          this.showPoint = false;
        }
      });
    },
    deleteUserMessageMark(id) {
      this.showPoint = false;
      let data = {
        liveId: id,
        userToken: this.userInfo.userToken,
        companyId: this.userInfo.companyId
      };
      this.$api.answerList.deleteUserMessageMark(data).then(res => {
        if (res.data.code == 0 && res.data.result == true) {
          this.showPoint = false;
        }
      });
    },

    showBig(pic) {
      if (this.showActive == 0) {
        for (var i in this.imagesArrCommon) {
          if (this.imagesArrCommon[i] == pic) {
            this.instance_before = ImagePreview({
              images: this.imagesArrCommon,
              startPosition: Number(i),
              loop: false,
              showIndex: false
            });
          }
        }
      } else if (this.showActive == 1) {
        for (var i in this.imagesArrAnalyst) {
          if (this.imagesArrAnalyst[i] == pic) {
            this.instance_after = ImagePreview({
              images: this.imagesArrAnalyst,
              startPosition: Number(i),
              loop: false,
              showIndex: false
            });
          }
        }
      } else if (this.showActive == 3) {
        for (var i in this.imagesArrMe) {
          if (this.imagesArrMe[i] == pic) {
            this.instance_third = ImagePreview({
              images: this.imagesArrMe,
              startPosition: Number(i),
              loop: false,
              showIndex: false
            });
          }
        }
      }
    },
    showImgLoad() {
      this.showLoad = true;
    },
    focus() {
      this.showFocusBg = true;
    },
    hideBg() {
      this.showFocusBg = false;
      this.$refs.inputArea.blur();
    },
    _initScroll() {
      this.$nextTick(() => {
        if (!this.scroll) {
          let _this = this;
          this.scroll = new BScroll(this.$refs.wrapper, {
            click: true
          });
          let Lis = this.$refs.container.querySelectorAll("li"); // 查找所有li元素
          this.scroll.scrollToElement(Lis[Lis.length - 1], 300);
          this.scroll.on("touchEnd", pos => {
            //下拉动作
            if (pos.y > 20) {
              this.showLoading = true;
              this.getMessageList();
            }
            this.scroll.refresh();
          });
        } else {
          this.scroll.refresh();
          this.showLoading = false;
        }
      });
    },
    goToProduct(message){
     let  code = message.substring(message.indexOf('aaa')+3,message.lastIndexOf('bbb'))
      this.echartsCode = code

      this.getCodeData(code)

    },
    getCodeData(code){
      this.$api.strageList.getProductDataSingle(code).then(res => {
        if (res.data.data.length != 0) {

             this.showCharts = true
             this.showPopupCharts = true
        }else{
            this.showCharts = false
             this.showPopupCharts = false

        }
      })
    },
    close(){
      this.showPopupCharts = false
    }


  },
  components: {
    Header,
    Top,
    loginPopup,
    inputArea,
    reLogin,
    loadIng,
    answerParty,
    eCharts
  },
  mounted() {
    this.autodivheight();
    if (!/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
      this.pc = true;
    }
    if (
      getStore("userInfoAll") == undefined ||
      getStore("userInfoAll") == null ||
      getStore("userInfoAll") == ""
    ) {
      if (
        getStore("noneheader") == null ||
        getStore("noneheader") == "" ||
        getStore("noneheader") == undefined
      ) {
        this.$router.replace("/login");
        return;
      } else {
        // window.location.href = "intercept_login";
        window.location.replace("/intercept_login")
        return;
      }
    }
    this.userInfo = JSON.parse(getStore("userInfoAll"));
    this.companyId = this.userInfo.companyId;
    this.liveId = this.$route.query.liveId;
    this.liveName = this.$route.query.liveName;
    if (this.$route.query.status == 1) {
      this.reactWebsocket = true;
    } else {
      this.reactWebsocket = false;
    }
    if (this.liveId) {
      // 查询单节课的信息
      this.getLiveInfo(this.liveId);
      //加载实时问答的历史消息
      this.loadHistoryMessage(this.liveId);
      //加载置顶消息
      // this.getTopHistoryMessage(this.liveId)
      //查询用户的消息数量
      this.getServiceMessageCount(this.liveId);
      this.loadAnalystHistoryMessage(this.liveId);
      this.loadAboutMeHistoryMessage(this.liveId);
      this.loadSeverHistoryMessage(this.liveId);
    }

    // 获取 请求的 唯一 id  uuid生成
    this.getRequestedId();
    this.getMessageId();
    // 初始化 公用的聊天信息
    this.initChatInfo();

    this.liveId = this.$route.query.liveId;
    this.liveName = this.$route.query.liveName;
    if (this.liveId && this.reactWebsocket) {
      this.initWebsocket();
    }
    this._initScroll();
    if (this.reactWebsocket) {
      setInterval(() => {
        let messageData = new MessageDataProto.MessageData();
        messageData.setMessagedatatype(
          MessageDataProto.MessageData.MessageDataType.ALIVE
        );
        if (webSocket == undefined || webSocket == null) {
          this.reconnect()
        } else {
          messageData.setMessage("ping");
          let messageArray = messageData.serializeBinary();
          if (this.stopHeart == false) {
            return;
          } else {
            if (webSocket.readyState === 1) {
              webSocket.send(messageArray);
            }
          }
        }
      }, 3000);
    }
  },
  filters: {
    filterText(val) {
      if (val == 0) {
        return "未开始";
      } else if (val == 1) {
        return "进行中";
      } else {
        return "已结束";
      }
    },
    subTime(val) {
      if (val) {
        return val.substring(11, 16);
      }
    },
    filterImage(val) {
      if (val != "") {
        return val;
      } else {
        return require("../../assets/images/user.png");
      }
    }
  },

  updated() {
    this.$nextTick(() => {
      if (this.ifLoadData) {
        if (this.loadMoreMessage == "loadMore") {
          if (this.dataLength > 0) {
            let LisMore = this.$refs.container.querySelectorAll("li");
            let times;
            times = Math.ceil(String(LisMore.length / 10)) - 1;
            this.scroll.scrollToElement(
              LisMore[LisMore.length - (10 * times + 1)]
            );
          } else if (this.loadMoreMessage == "") {
            this.scroll.scrollTo(0, 0);
          }
          this.showMoreContent = true;
        }
      } else {
        if (this.lockLock) {
          let Lis = this.$refs.container.querySelectorAll("li"); // 查找所有li元素
          if (this.scroll && this.scrollToElement) {
            this.scroll.scrollToElement(Lis[Lis.length - 1], 300); // 滑动到指定元素,设置动画300ms
          }
        }
      }
      this.dataLength = 0;
    });
  }
};
</script>

<style lang="scss" scoped>
@import "~assets/styles/mixin";
.chat_wrapper {
  background: #f0f1f5;
  height: 100%;
  position: fixed;
  width: 100%;
  top: 0px;
}
.chat_wrapper.pc {
  position: relative;
}
.chat_wrapper.fucture {
  position: relative;
}
.title_area {
  @include fj();
  background: #fff;
  font-size: 0;
  padding: 0.15rem 0.3rem 0.15rem 0;
  .title_left {
    width: 35%;
    text-align: center;
    img {
      @include wh(0.8rem, 0.84rem);
      display: block;
      margin: 0 auto 0.05rem;
    }
    span {
      @include sc(0.28rem, #485266);
      font-weight: bold;
    }
  }
  .title_right {
    width: 65%;
    .right_top {
      display: flex;
      justify-content: space-between;
      align-items: inherit;
      .top_left {
        @include sc(0.32rem, #333);
        width: 91%;
        word-wrap: break-word;
        word-break: break-all;
        overflow: hidden;
        line-height: 0.44rem;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .top_right {
        @include wh(0.3rem, 0.3rem);
        @include bis("../../assets/images/icon-sprite.png", 3.34rem, 3.2rem);
        @include bp(-1.66rem, -1.92rem);
        position: relative;
        .info {
          position: absolute;
          padding: 0.1rem 0.25rem;
          @include sc(0.25rem, #fff);
          background: rgba(0, 0, 0, 1);
          opacity: 0.8;
          border-radius: 0.06rem;
          line-height: 0.4rem;
          width: 6rem;
          right: -0.2rem;
          top: 0.45rem;
          z-index: 1;
          &:after {
            content: "";
            position: absolute;
            top: -0.25rem;
            right: 0.22rem;
            width: 0;
            height: 0;
            border-width: 0.14rem;
            border-style: solid;
            border-color: transparent transparent #000 transparent;
          }
        }
      }
    }
    .right_bottom {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      .bottom_left {
        ul {
          display: flex;
          font-size: 0;
          li {
            background: rgba(246, 247, 251, 1);
            @include borderRadius(0.06rem);
            @include sc(0.24rem, #0a95ff);
            text-align: center;
            padding: 0.08rem 0.2rem;
            margin-bottom: 0;
            margin-right: 0.1rem;
          }
        }
      }
      .bottom_right {
        font-size: 0;
        span {
          @include sc(0.2rem, #999);
        }
        .status {
          text-align: right;
          i {
            display: inline-block;
            vertical-align: middle;
            @include wh(0.22rem, 0.22rem);
            @include bis("~assets/images/icon-sprite.png", 3.34rem, 3.2rem);
            margin-right: 0.1rem;
          }
          span {
            vertical-align: middle;
          }
          @include sc(0.24rem, #e7a70c);
        }
        .status.ing {
          i {
            @include bp(-3.02rem, -0.52rem);
          }
          color: #e7a70c;
        }
        .status.future {
          i {
            @include bp(-3.02rem, -0.1rem);
          }
          color: #e7a70c;
        }
        .status.ever {
          i {
            @include bp(-3.02rem, -0.94rem);
          }
          color: #c1bebe;
        }
      }
    }
  }
}
.tab_list {
  background: #fff;
  position: relative;
  ul {
    display: flex;
    padding: 0.2rem 0;
    border-top: 0.025rem solid #ddd;
    border-bottom: 0.025rem solid #ddd;
    justify-content: center;
    li {
      @include sc(0.28rem, #666);
      border-right: 0.025rem solid #ddd;
      padding: 0 0.3rem;
    }
    li.active {
      color: #0a95ff;
    }
    li:last-child {
      border-right: 0;
    }
  }
  i {
    position: absolute;
    display: block;
    width: 0.15rem;
    height: 0.15rem;
    border-radius: 50%;
    background: red;
    right: 0.4rem;
    top: 0.2rem;
  }
}
.chat_part {
  position: relative;
}
.chat_part.top {
  padding-top: 2.6rem;
}
.chat_inner {
  overflow: hidden;
  overflow-y: scroll;
  padding-bottom: 2rem;
  position: relative;
  background: #f0f0f0;
}
.chat_inner.heightAdd {
  padding-bottom: 2.3rem;
  .live_info {
    bottom: 1.65rem;
  }
}
.live_info {
  @include sc(0.24rem, #fff);
  position: fixed;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  bottom: 1.4rem;
  background: rgba(0, 0, 0, 0.5);
  padding: 0.05rem 0.1rem;
  border-radius: 0.06rem;
}
.hope_time {
  @include sc(0.24rem, #666);
  text-align: center;
  margin: 0.3rem 0 0.23rem;
}
.hot_list {
  padding: 0 0.3rem;
  .title {
    font-size: 0;
    margin-bottom: 0.3rem;
    img {
      @include wh(1.46rem, 0.46rem);
    }
  }
}

.chat_list {
  li {
    background: #fff;
    border-radius: 0.06rem;
    margin: 0.2rem 0.1rem;
    padding-bottom: 0.3rem;
  }
}
.chat_top {
  padding: 0.2rem 0.2rem 0 0.18rem;
  @include fj();
  .ava {
    font-size: 0;
    img {
      @include wh(0.64rem, 0.64rem);
      vertical-align: middle;
      margin-right: 0.15rem;
    }
  }
  .name {
    @include sc(0.24rem, #e7a70c);
    vertical-align: middle;
  }
  .time {
    @include sc(0.24rem, #999);
  }
}
.chat_bottom {
  @include sc(0.28rem, #333);
  padding-left: 0.9rem;
  padding-right: 0.2rem;
  word-wrap: break-word;
  word-break: break-all;
  overflow: hidden;
  text-align: justify;
  .repeat_content {
    display: inline-block;
  }
}
.chat_bottom span {
  display: block;
  img.face_inner{
    width:0.5rem
  }
  img.litter_pic{
    width:2rem
  }
}
.repeat {
  border-top: 0.025rem solid #ddd;
  @include sc(0.28rem, #666);
  margin-top: 0.2rem;
  padding-top: 0.2rem;
  word-wrap: break-word;
  word-break: break-all;
  overflow: hidden;
  text-align: justify;
}
.serve_href {
  .serve_text {
    @include sc(0.28rem, #e7a70c);
    margin-bottom: 0.18rem;
  }
  a {
    display: inline-block;
    padding: 0.01rem 0.17rem;
    border: 0.025rem solid #e7a70c;
    @include sc(0.24rem, #e7a70c);
    text-align: center;
    border-radius: 0.06rem;
  }
}

.ask_img {
  margin-top: 0.2rem;
  img {
    width: 2.5rem;
  }
  .big_img {
    object-fit: contain;
    width: 100%;
    height: 100%;
    -webkit-user-drag: none;
  }
}
.van-popup--center {
  width: 100%;
}

.img_label {
  width: 5rem;
}
.cue_person {
  color: #0096dc;
}
.loading-wrapper {
  text-align: center;
  padding: 0.3rem 0;
}
.chat_wrapper_inner {
  height: 100%;
}
.litter_pic {
  width: 2rem;
}
.bigImg {
  width: 100%;
  border: 0;
}
.van-popup {
  background: none;
  text-align: center;
}
.focus_bg {
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
</style>
